import ExaminationSubmitButton from './ExaminationSubmitButton';

export default ExaminationSubmitButton;
